/*eslint @typescript-eslint/no-empty-function: "off" */
import { ThunkDispatch } from '@reduxjs/toolkit';
import { notifyError } from 'components/Notify/Notify';
import ItemManagerModal from '../ItemManagerModal';
import PageCKEditor from './PageCkEditor';
import $ from 'jquery';
import OpenItem from '../../DataClass/OpenItem';
import { connect, MapDispatchToProps } from 'react-redux';
import {
  update_ck,
  update_ckFn,
  updateItem,
  updateItemThumbnail,
} from 'store/providers/providerSlice';
import { Container, InfoItem } from '../DocumentViewerModal/styles';
import messages from '../DocumentViewerModal/message';
import { convertDigitToProperFormat } from 'utils/number';
import moment from 'moment-jalaali';
import MyModal from '../../../Modal';
import { Beforeunload } from 'react-beforeunload';
import { CustomDropzone } from '../../../CustomDropzone/CustomDropzone';
import { DropzoneRenderArgs } from 'react-dropzone';
import { IconItem } from '../../../Chart/styles';
import { store } from '../../../../index';
import extractImagesAndData, {
  IDetail,
} from '../../../../utils/scribeHowFetch/extractProps';
import { baseURL, proxyGet } from 'api/ManApi';
import { appDispatch } from 'store/store';
import { IProviderItemViewWithData } from 'store/providers/providerTypes';
import { getAccessToken, getDomainAndPort } from 'api/Utils';
import LocalIcon from '../../../../ui/LocalIcon';
import {
  HeaderContainer,
  HTMLEditorContainer,
  ListItemContainer,
  MainHeader,
  PreviewHTML,
  QuillContainer,
} from './styles';
import { black, exactWhite } from '../../../../utils/style/colors';
import i18n, { languageDirection } from '../../../../i18n';
import Input from '../../../Input/Input';
import Button from '../../../Button/Button';
import Helmet from 'react-helmet';
import { LoadingCircleIndicatorNoPad } from '../../../LoadingCircleIndicator/LoadingCircleIndicator';
import APopover from '../../../APopover/APopover';
import handleQuestionFromChatBot from '../../../../api/chatbot-api/AskQuestion';
import Select, { IOption } from '../../../Select/Select';
import CKEditorField from '../../../CKEditorField/CKEditorField';
import React from 'react';
import { display } from '../../../ErrorView/ErrorDialog';
import cloneDeep from 'lodash/cloneDeep';
import Collapsible from '../../../Collapsible/Collapsible';
import Textarea from 'components/Textarea';
import HeaderThumbnail from '../HeaderThumbnail';

export const CKEditorConfig = {
  toolbar: {
    items: ['fontColor', 'heading', 'bold'],
  },
  language: i18n.language,
};

type ComponentStates = {
  content?: string;
  saving: boolean;
  loading?: boolean;
  unsaved: boolean;
  isScribeHowPage: boolean;
  access_token: string;
  scribeHowHtmlExtractedData: IDetail[];
  scribePageTitle: string;
  scribeHowAssets: Array<{ name: string; file: string | ArrayBuffer }>;
  isDropZoneLoading: boolean;
  isNews: boolean;
  askedNewsContent: string;
  searchingNews: boolean;
  selectedChatOption?: IOption;
  hasDescription: boolean;
  description: string;
  savingDescription: boolean;
  enableHtmlEditor: boolean;
  moreInfoLink: string;
  savingMoreInfoLink: boolean;
  savingThumbnail: boolean;
  enableSystemInstruction: boolean;
  systemInstruction: string;
  enableSearch: boolean;
};

type StateToProps = Record<string, unknown>;

type DispatchProps = {
  save: (
    content: any,
    item: IProviderItemViewWithData
  ) => ReturnType<typeof update_ckFn>;
};

type OwnProps = {
  openItem: OpenItem;
  changeState: (activeTab: string) => any;
  dispatch: ThunkDispatch<any, never, any>;
  isOpen: boolean;
  onMinimize?: (() => any) | undefined;
  showHome?: boolean;
  save: (htmlNode: string | undefined, item: IProviderItemViewWithData) => any;
  onClose: () => void | null | undefined;
};

type ComponentProps = StateToProps & DispatchProps & OwnProps;

class QuillManagerModal extends ItemManagerModal<OwnProps, ComponentStates> {
  state: ComponentStates = {
    loading: true,
    unsaved: false,
    saving: false,
    content: undefined,
    isScribeHowPage: false,
    access_token: getAccessToken(store.getState())!,
    scribeHowHtmlExtractedData: [],
    scribeHowAssets: [],
    isDropZoneLoading: false,
    scribePageTitle: '',
    isNews: false,
    askedNewsContent: '',
    searchingNews: false,
    selectedChatOption: undefined,
    hasDescription: false,
    description: '',
    savingDescription: false,
    enableHtmlEditor: false,
    moreInfoLink: this.props.openItem.item.data.moreInfoUrl ?? '',
    savingMoreInfoLink: false,
    savingThumbnail: false,
    enableSystemInstruction: false,
    systemInstruction: '',
    enableSearch: true,
  };

  chatBotOptions: IOption[] = [
    {
      label: `${i18n.t('createAutoNews', { ns: 'taskManager' })}`,
      value: 'asst_Auv2wEk7RuoXQck9rudGRsVY',
      description: `${
        i18n.t('askingNews', {
          ns: 'taskManager',
        }) as string
      }`,
    },
    // {
    //   label: `${i18n.t('optimization', { ns: 'taskManager' })}`,
    //   value: 'asst_sAqjNkb9XeqspMFe9RzxCLMh',
    //   description: `${i18n.t('optimizingText', { ns: 'taskManager' })}`,
    // },
  ];

  constructor(props: ComponentProps) {
    super(props);
    this.unsave = false;
    this.isOpen = false;
  }

  componentDidMount() {
    super.componentDidMount();
    const url = this.props.openItem.item.data.document.url;
    if (url)
      $.get(url, null, ((data: any) => {
        const c = data.replaceAll(
          /<figure[^>]*>[^<]*<img>[^<]*<\/figure>/gi,
          ''
        );
        this.setState({ content: c, loading: false });
      }) as any).fail(() => {
        proxyGet(url).then((res) => {
          this.setState({ content: res.data, loading: false });
        });
      });
    else {
      this.setState({ content: '', loading: false });
    }

    if (this.props.openItem.item.data) {
      this.setState({ description: this.props.openItem.item.data.description });
    }
  }

  save = () => {
    this.setState({ saving: true });
    const htmlNode = this.state.content;
    return this.props
      .save(htmlNode, this.props.openItem.item)
      .then(() => {
        this.setState({ saving: false, unsaved: false });
      })
      .catch((err: any) => {
        notifyError(err.message);
        this.setState({ saving: false });
      });
  };

  handleUpdateContent = (content: string) => {
    this.setState({ content, unsaved: true });
  };

  handleChangemoreInfoLink = (event: any) => {
    this.setState({ moreInfoLink: event.target.value });
  };

  handleUpdateScribeHowContent = (scribeHowContent: Array<IDetail>) => {
    let content = `<h2>${this.state.scribePageTitle}</h2>`;
    let index = 0;
    scribeHowContent.forEach((detail) => {
      if (detail.title && detail.wrapperStatus !== 'info') {
        content +=
          '<figure class="table" style="width:100%;"><table style="border-radius: 12px;"><tbody><tr>';
        detail.title.forEach((txtObject, idx) => {
          content += `<td style="${
            detail.wrapperStatus === 'success'
              ? 'background-color:hsl(120, 75%, 60%);'
              : detail.wrapperStatus === 'danger'
                ? 'background-color:hsl(30, 75%, 60%);'
                : ''
          }">`;
          if (txtObject.type === 'a') {
            content += `<a target="_blank" rel="noopener noreferrer" href="${txtObject.href}"><span><strong>${txtObject.text}</strong></span></a>`;
          } else if (txtObject.type === 'b') {
            content += `<span><strong>${txtObject.text}</strong></span>`;
          } else if (txtObject.type === 'i') {
            content += `<span><i>${txtObject.text}</i></span>`;
          } else if (txtObject.type === 'br') {
            content += detail.title?.length === idx + 1 ? '' : '</td></tr><tr>';
          } else if (txtObject.type === 'p') {
            content += `<span>${txtObject.text}</span></td></tr><tr>`;
          } else {
            content += `<span>${txtObject.text}</span>`;
          }
        });

        content += '</td></tr></tbody></table></figure>';
      }

      if (detail.title && detail.wrapperStatus === 'info') {
        content += `<p><strong> ${convertDigitToProperFormat(++index)}. </strong> `;
        detail.title.forEach((txtObject, idx) => {
          if (txtObject.type === 'a') {
            content += `<a target="_blank" rel="noopener noreferrer" href="${txtObject.href}"><span>${txtObject.text}</span></a>`;
          } else if (txtObject.type === 'b') {
            content += `<span><strong>${txtObject.text}</strong></span>`;
          } else if (txtObject.type === 'i') {
            content += `<span><i>${txtObject.text}</i></span>`;
          } else if (txtObject.type === 'br') {
            content += detail.title?.length === idx + 1 ? '' : '</p><p>';
          } else {
            content += `<span>${txtObject.text}</span>`;
          }
        });
        content += '</p>';
      }

      if (detail.imageSrc) {
        content += `<figure class="image" alt="" style="position: relative; aspect-ratio: 688 / 384; margin: auto; width: 688px; overflow: hidden;"><img src="${detail.imageSrc}"></figure>`;
      }
    });

    this.handleUpdateContent(content);
  };

  handleAddHtmlFile = (acceptedFiles: DropzoneRenderArgs['acceptedFiles']) => {
    this.setState({ isDropZoneLoading: true });
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event.target?.result) {
        const { extractedData, pageTitle } = extractImagesAndData(
          event.target.result as string
        );
        this.setState({
          isDropZoneLoading: false,
          scribeHowHtmlExtractedData: extractedData as IDetail[],
          scribePageTitle: pageTitle,
        });
      }
    };
    reader.readAsText(acceptedFiles[0]);
  };

  uploadAssetFile = async (upload: any) => {
    const form = new FormData();
    form.append('upload', upload);
    return fetch(baseURL + '/file/addTempImage', {
      method: 'POST',
      headers: {
        Authorization: this.state.access_token,
        'Access-Control-Request-Headers': '',
        accept: 'application/json',
      },
      body: form,
    })
      .then((response) => response.json())
      .then((success) => success.url)
      .catch(() => {
        /*do nothing*/
      });
  };

  handleImageCropAndAddMarker = (
    file: DropzoneRenderArgs['acceptedFiles'][0],
    state: IDetail
  ): Promise<File | boolean> => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const image = new Image();
        image.src = event.target?.result as string;

        image.onload = () => {
          const width = 688;
          const height = 384;
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d')!;
          canvas.width = width;
          canvas.height = height;

          try {
            const left =
              -1 * Number(state.imgStyle?.left.replace('px', '')) || 0;
            const top = -1 * Number(state.imgStyle?.top.replace('px', '')) || 0;

            const scaleX =
              Number(state.imgStyle!.width.replace('px', '')) /
              image.naturalWidth;
            const scaleY =
              Number(state.imgStyle!.height.replace('px', '')) /
              image.naturalHeight;
            const scale = Math.min(scaleX, scaleY);

            context.drawImage(
              image,
              left / scale,
              top / scale,
              width / scale,
              height / scale,
              0,
              0,
              width,
              height
            );

            if (state?.markerPosition?.x && state?.markerPosition?.y) {
              const markerXPosition = Number(
                state.markerPosition!.x!.replace('px', '')
              );
              const markerYPosition = Number(
                state.markerPosition!.y!.replace('px', '')
              );

              context.beginPath();
              context.arc(
                markerXPosition + 30,
                markerYPosition + 30,
                30,
                0,
                2 * Math.PI
              );
              context.fillStyle = 'rgba(251, 146, 60, 0.3)';
              context.fill();
              context.beginPath();
              context.arc(
                markerXPosition + 30,
                markerYPosition + 30,
                32,
                0,
                2 * Math.PI
              );
              context.strokeStyle = 'rgba(251, 146, 60, 1)';
              context.stroke();
            }

            const newDataUrl = canvas.toDataURL('image/png', 1);
            const byteString = atob(newDataUrl.split(',')[1]);
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const intArray = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteString.length; i++) {
              intArray[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([arrayBuffer], {
              type: 'image/jpeg' || newDataUrl.split(';')[0].split(':')[1],
            });

            resolve(new File([blob], file.name, { type: 'image/png' }));
          } catch (error) {
            resolve(false);
          }
        };
      };
      reader.readAsDataURL(file);
    });
  };

  handleChangeDescription = (data: string) => {
    this.setState({ description: data });
  };

  handleAddAssetFiles = async (
    acceptedFiles: DropzoneRenderArgs['acceptedFiles']
  ) => {
    if (this.state.scribeHowHtmlExtractedData.length === 0) {
      return alert('upload the html file first!');
    }
    const images = acceptedFiles.filter((img) => img.type.startsWith('image/'));
    if (images.length === 0) {
      return alert('there is no image with the assets file!');
    }
    this.setState({ isDropZoneLoading: true });

    let bindHtmlImgWithAssets: any = await Promise.allSettled(
      this.state.scribeHowHtmlExtractedData.map(async (state) => {
        const foundImage = images.find((img) => img.name === state.imgName);

        if (foundImage) {
          const file = await this.handleImageCropAndAddMarker(
            foundImage!,
            state
          );
          if (file) {
            const imageUrl = await this.uploadAssetFile(file);
            return {
              ...state,
              imageSrc: imageUrl,
            };
          } else {
            return {
              ...state,
              imageSrc: '',
            };
          }
        } else {
          return {
            ...state,
            imageSrc: '',
          };
        }
      })
    );

    bindHtmlImgWithAssets = bindHtmlImgWithAssets
      .map((binded: any) => {
        if (binded.status === 'fulfilled') {
          return binded.value;
        } else {
          return false;
        }
      })
      .filter((itm: any) => Boolean(itm));
    if (bindHtmlImgWithAssets.length === 0) {
      return alert('assets and html file may be not from the same page!');
    }
    this.handleUpdateScribeHowContent(bindHtmlImgWithAssets as IDetail[]);
    this.setState({ isDropZoneLoading: false });
  };

  handleAskedQuestionToChatBot = async () => {
    this.setState({ searchingNews: true });
    const {
      enableSearch,
      enableSystemInstruction,
      systemInstruction,
      content,
      askedNewsContent,
    } = this.state;
    const question = `Current Content: ${content}\nQuestion: ${askedNewsContent}`;
    const instruction = [
      {
        role: 'developer',
        content: [
          {
            type: 'input_text',
            text: enableSystemInstruction
              ? systemInstruction
              : 'You are a helpful, professional reporter assistant that can extract the news from the content and return it in a text format. Your response should precise and follow all news regarding it. Note: Do not get back with question and try to generate whatever the user is asking for.',
          },
        ],
      },
      {
        role: 'user',
        content: [{ type: 'input_text', text: question }],
      },
    ];
    const { text: result } = await handleQuestionFromChatBot(
      instruction,
      enableSearch
    );
    this.setState({
      searchingNews: false,
      askedNewsContent: '',
      enableSearch: true,
      systemInstruction: '',
      enableSystemInstruction: false,
    });
    if (result) {
      this.setState({
        content: `<p>${result}</p>`,
      });
    }
  };

  render(): any {
    const { openItem, showHome } = this.props;
    const item = this.props.openItem.item;
    const fullScreen = item.data.tags.find(
      (t: any) => t.text === 'conf_fullscreen'
    );
    const { content } = this.state;
    if (openItem.item.data.editable && !openItem.item.data.upstreamItemId)
      return super.render();
    return (
      <>
        <Helmet>
          <title>{openItem.item.data.name}</title>
        </Helmet>
        <MyModal
          onClose={() => this.props.onClose()}
          title={item.data.name as string}
          isActive={true}
          width={fullScreen ? '100%' : undefined}
          height={fullScreen ? '100%' : undefined}
          sideElements={
            <Button
              onClick={() => {
                try {
                  navigator.share({
                    title: item.data.name,
                    url: window.location.href,
                  });
                } catch (error) {
                  /*do nothing*/
                }
              }}
            >
              {i18n.t('share', { ns: 'modals' }) as string}
            </Button>
          }
          showHome={showHome}
        >
          {' '}
          <PageCKEditor
            item={item}
            editing={false}
            updateContent={() => {}}
            saving={false}
            content={content}
          />
        </MyModal>
      </>
    );
  }

  handleSaveMoreInfoLink = () => {
    const item = cloneDeep(this.props.openItem.item.data);
    item.moreInfoUrl = this.state.moreInfoLink;
    this.setState({ savingMoreInfoLink: true });
    appDispatch(updateItem({ item }) as any).then(
      () => {
        this.setState({ savingMoreInfoLink: false });
      },
      (err: any) => {
        display(err);
      }
    );
  };

  handleSaveDescription = () => {
    const item = cloneDeep(this.props.openItem.item.data);
    item.description = this.state.description;
    this.setState({ savingDescription: true });
    appDispatch(updateItem({ item }) as any).then(
      () => {
        this.setState({ savingDescription: false });
      },
      (err: any) => {
        display(err);
      }
    );
  };

  async handleAddIconThroughContent() {
    const item = cloneDeep(this.props.openItem.item.data);
    const html = this.state?.content || '';

    this.setState({ savingThumbnail: true });
    const matches = [...html.matchAll(/<img[^>]+src=["']([^"']+)["'][^>]*>/gi)];
    if (matches?.length > 0) {
      const thumbnailUrl = matches?.[0]?.[1];
      const response = await fetch(thumbnailUrl);
      const blob = await response.blob();
      appDispatch(updateItemThumbnail({ item, blob })).then(
        () => {
          this.setState({ savingThumbnail: false });
        },
        (err: any) => {
          display(err);
        }
      );
    }
  }

  renderChild() {
    const item = this.props.openItem.item;
    if (item.data.document.properties.format !== 'quill') {
      return (
        <div>
          {'document format is ' +
            item.data.document.properties.format +
            '. quill expected'}
        </div>
      );
    }

    const { onClose, openItem, changeState, onMinimize } = this.props;
    const { content, saving, loading, unsaved, isNews } = this.state;
    const allowScribe = openItem.item.data.providerId === 2 || true;
    const showBot = getDomainAndPort().domainFeatures?.enableSmartBot || false;

    return (
      <>
        {unsaved && (
          <Beforeunload onBeforeunload={() => messages.changeWillBeLost} />
        )}
        <QuillContainer>
          <header
            style={{ boxShadow: 'none', border: 'none', padding: '0.5rem 0' }}
          >
            <HeaderContainer>
              <ul
                id="navigation-buttons"
                className="right"
                style={{ display: 'flex' }}
              >
                {onClose && (
                  <ListItemContainer>
                    <LocalIcon
                      iconName="close-square.svg"
                      color="no-color"
                      type={'sm'}
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          !unsaved ||
                          confirm(
                            i18n.t('changeWillBeLost', { ns: 'taskManager' })
                          )
                        )
                          onClose();
                      }}
                    />
                  </ListItemContainer>
                )}
                {onMinimize && (
                  <ListItemContainer>
                    <LocalIcon
                      iconName="minimize.svg"
                      color="no-color"
                      type={'sm'}
                      onClick={(e) => {
                        e.preventDefault();
                        onMinimize();
                      }}
                      style={{ height: '100%' }}
                    />
                  </ListItemContainer>
                )}
              </ul>
              <HeaderThumbnail item={item.data} />
              <MainHeader>{item.data.name}</MainHeader>
              {openItem.item.data.editable && (
                <ul id="textNav" className="left flex gap-2">
                  {openItem.status !== 'edit' && (
                    <Button
                      color="primary-color"
                      loading={this.state.savingThumbnail}
                      onClick={() => this.handleAddIconThroughContent()}
                    >
                      {
                        i18n.t('addThumbnailThroughContent', {
                          ns: 'documentManager',
                        }) as string
                      }
                    </Button>
                  )}
                  {this.state.saving ? (
                    <li>
                      <div
                        style={{
                          padding: '4px 0px 0px 10px',
                        }}
                      >
                        <LoadingCircleIndicatorNoPad
                          innerStyle={{
                            width: '20px',
                            height: '20px',
                          }}
                        />
                      </div>
                    </li>
                  ) : openItem.status === 'edit' ? (
                    <ListItemContainer>
                      <LocalIcon
                        iconName="save.svg"
                        type="sm"
                        color={black}
                        isLink={true}
                        onClick={async (e: any) => {
                          e.preventDefault();
                          await this.save.bind(this)();
                          changeState('view');
                        }}
                      />
                    </ListItemContainer>
                  ) : (
                    <ListItemContainer>
                      <LocalIcon
                        iconName="edit.svg"
                        type="sm"
                        color={black}
                        isLink={true}
                        onClick={(e) => {
                          e.preventDefault();
                          changeState('edit');
                        }}
                      />
                    </ListItemContainer>
                  )}
                </ul>
              )}
            </HeaderContainer>
          </header>
          <div
            className="modal-content flex-box row"
            style={{
              padding: '0px',
              backgroundColor: 'var(--exact-white)',
              display: 'flex',
            }}
          >
            <div className="col s12 m12 l10">
              {loading ? (
                <div className="progress">
                  <div className="indeterminate" />
                </div>
              ) : this.state.enableHtmlEditor ? (
                <HTMLEditorContainer>
                  <h4>
                    {i18n.t('preview', { ns: 'documentManager' }) as string}
                  </h4>
                  <PreviewHTML>
                    <PageCKEditor
                      item={item}
                      editing={false}
                      updateContent={() => {}}
                      saving={false}
                      content={content}
                    />
                  </PreviewHTML>
                  <h4>
                    {i18n.t('editor', { ns: 'documentManager' }) as string}
                  </h4>
                  <Textarea
                    id={'HTML_editor'}
                    dir="ltr"
                    rows={15}
                    disabled={openItem.status !== 'edit'}
                    onChange={(e) => this.handleUpdateContent(e.target.value)}
                    placeholder={i18n.t('HTMLContent')}
                    value={content}
                  />
                </HTMLEditorContainer>
              ) : (
                <PageCKEditor
                  item={item}
                  editing={openItem.status === 'edit'}
                  updateContent={this.handleUpdateContent}
                  saving={saving}
                  content={content}
                />
              )}
            </div>
            <div
              className="col s12 m12 l2"
              style={{
                padding: '1rem',
                alignSelf: 'flex-start',
              }}
            >
              <Container style={{ height: '100%' }}>
                <InfoItem>
                  <b>
                    {i18n.t('uploadDate', { ns: 'taskManager' }) as string} :
                  </b>
                  <span>
                    {i18n.language === 'fa'
                      ? convertDigitToProperFormat(
                          moment(openItem.item.data.creationDate).format(
                            'jD jMMMM jYYYY'
                          )
                        )
                      : moment(openItem.item.data.creationDate)
                          .locale('en')
                          .format('MMMM D YYYY')}
                  </span>
                </InfoItem>
              </Container>
              {allowScribe && openItem.status === 'edit' && (
                <Container
                  style={{
                    marginTop: '1rem',
                  }}
                >
                  <>
                    <InfoItem>
                      <Input
                        type="checkbox"
                        id="enableHTMLEditor"
                        name="enableHTMLEditor"
                        checked={this.state.enableHtmlEditor}
                        onChange={() =>
                          this.setState({
                            enableHtmlEditor: !this.state.enableHtmlEditor,
                          })
                        }
                      />
                      <label htmlFor="enableHTMLEditor">
                        {
                          i18n.t('enbaleHtmlEditor', {
                            ns: 'documentManager',
                          }) as string
                        }
                      </label>
                    </InfoItem>
                    {/* <InfoItem>
                      <Input
                        type="checkbox"
                        id="isScribeHow"
                        name="isScribeHow"
                        value="newsletter"
                        onChange={(_) => {
                          this.setState({
                            isScribeHowPage: !this.state.isScribeHowPage,
                          });
                        }}
                      />
                      <label htmlFor="isScribeHow">
                        Is{' '}
                        <a
                          href="https://scribehow.com/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          scribeHow
                        </a>{' '}
                        page?
                      </label>
                    </InfoItem> */}
                    {this.state.isDropZoneLoading ? (
                      <span>
                        {i18n.t('processing', { ns: 'taskManager' }) as string}
                      </span>
                    ) : this.state.isScribeHowPage ? (
                      <IconItem>
                        <CustomDropzone
                          onDrop={this.handleAddHtmlFile}
                          multiple={false}
                          accept="text/html"
                          disabled={this.state.isDropZoneLoading}
                          style={{
                            width: '100%',
                            height: '100%,',
                            textAlign: 'center',
                            position: 'relative',
                            borderWidth: '2px',
                            borderColor: 'rgb(102, 102, 102)',
                            borderStyle: 'dashed',
                            borderRadius: '5px',
                          }}
                        >
                          {this.state.isDropZoneLoading ? (
                            <span>
                              {
                                i18n.t('processing', {
                                  ns: 'taskManager',
                                }) as string
                              }
                            </span>
                          ) : this.state.scribeHowHtmlExtractedData.length ? (
                            <span>
                              {
                                i18n.t('loaded', {
                                  ns: 'taskManager',
                                }) as string
                              }
                            </span>
                          ) : (
                            <span>
                              {
                                i18n.t('pleaseSelectScribeHowHtml', {
                                  ns: 'taskManager',
                                }) as string
                              }
                            </span>
                          )}
                        </CustomDropzone>
                        {!!this.state.scribeHowHtmlExtractedData.length && (
                          <CustomDropzone
                            onDrop={this.handleAddAssetFiles}
                            // accept="image/*"
                            disabled={this.state.isDropZoneLoading}
                            style={{
                              width: '100%',
                              height: '100%,',
                              textAlign: 'center',
                              position: 'relative',
                              borderWidth: '2px',
                              borderColor: 'rgb(102, 102, 102)',
                              borderStyle: 'dashed',
                              borderRadius: '5px',
                              marginTop: '1rem',
                            }}
                          >
                            {this.state.isDropZoneLoading ? (
                              <span>
                                {
                                  i18n.t('processing', {
                                    ns: 'taskManager',
                                  }) as string
                                }
                              </span>
                            ) : (
                              <span>
                                {
                                  i18n.t('pleaseSelectScribeHowAssets', {
                                    ns: 'taskManager',
                                  }) as string
                                }
                              </span>
                            )}
                          </CustomDropzone>
                        )}
                      </IconItem>
                    ) : null}
                  </>
                </Container>
              )}
              {openItem.status === 'edit' && (
                <Container className="my-4">
                  <div style={{ padding: '1rem' }}>
                    <Collapsible
                      key={'hasDescription'}
                      headerBackgroundColor={exactWhite}
                      customCollapsibleHeaderStyle={{ zIndex: 1000 }}
                      header={`${
                        i18n.t('description', {
                          ns: 'taskManager',
                        }) as string
                      }`}
                      customHeaderStyle={{ flexGrow: 1, display: 'block' }}
                      customBodyStyle={{ padding: 0 }}
                      onOpen={() => this.setState({ hasDescription: true })}
                      onClose={() => this.setState({ hasDescription: false })}
                      isOpen={this.state.hasDescription}
                    >
                      <div
                        style={{
                          padding: '1rem',
                          margin: '0rem',
                          width: '100%',
                          background: 'var(--exact-white)',
                          gap: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <CKEditorField
                          label={
                            i18n.t('nameTitle', {
                              ns: 'documentManager',
                            }) as string
                          }
                          onChange={(_: any, editor: any) => {
                            const data = editor.getData();
                            this.handleChangeDescription(data);
                          }}
                          data={this.state.description}
                          dir={`${languageDirection()}`}
                          config={CKEditorConfig}
                        />
                        <Button
                          type="button"
                          color={'black-outline'}
                          onClick={this.handleSaveDescription}
                          loading={this.state.savingDescription}
                        >
                          {
                            i18n.t('confirm', {
                              ns: 'taskManager',
                            }) as string
                          }
                        </Button>
                      </div>
                    </Collapsible>
                    {/*<Input*/}
                    {/*  id="hasDescription"*/}
                    {/*  type="checkbox"*/}
                    {/*  label={`${*/}
                    {/*    i18n.t('description', {*/}
                    {/*      ns: 'taskManager',*/}
                    {/*    }) as string*/}
                    {/*  }`}*/}
                    {/*  checked={this.state.hasDescription}*/}
                    {/*  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>*/}
                    {/*    this.setState({ hasDescription: e.target.checked })*/}
                    {/*  }*/}
                    {/*/>*/}
                    {/*{this.state.hasDescription && (*/}
                    {/*  <APopover*/}
                    {/*    show={this.state.hasDescription}*/}
                    {/*    curveBorder={true}*/}
                    {/*    marginToTarget={8}*/}
                    {/*    placement={'bottom'}*/}
                    {/*    target={<div></div>}*/}
                    {/*  >*/}
                    {/*    <div*/}
                    {/*      style={{*/}
                    {/*        padding: '1rem',*/}
                    {/*        margin: '2rem 0rem',*/}
                    {/*        width: '25rem',*/}
                    {/*        background: exactWhite,*/}
                    {/*        gap: '1rem',*/}
                    {/*        display: 'flex',*/}
                    {/*        flexDirection: 'column',*/}
                    {/*      }}*/}
                    {/*    >*/}
                    {/*      <CKEditorField*/}
                    {/*        label={*/}
                    {/*          i18n.t('nameTitle', {*/}
                    {/*            ns: 'documentManager',*/}
                    {/*          }) as string*/}
                    {/*        }*/}
                    {/*        onChange={(_: any, editor: any) => {*/}
                    {/*          const data = editor.getData();*/}
                    {/*          this.handleChangeDescription(data);*/}
                    {/*        }}*/}
                    {/*        data={this.state.description}*/}
                    {/*        dir={`${languageDirection()}`}*/}
                    {/*        config={CKEditorConfig}*/}
                    {/*      />*/}
                    {/*      <Button*/}
                    {/*        type="button"*/}
                    {/*        color={'black-outline'}*/}
                    {/*        onClick={this.handleSubmitDescription}*/}
                    {/*        loading={this.state.savingDescription}*/}
                    {/*      >*/}
                    {/*        {*/}
                    {/*          i18n.t('confirm', {*/}
                    {/*            ns: 'taskManager',*/}
                    {/*          }) as string*/}
                    {/*        }*/}
                    {/*      </Button>*/}
                    {/*    </div>*/}
                    {/*  </APopover>*/}
                    {/*)}*/}
                  </div>
                </Container>
              )}
              {openItem.status === 'edit' && (
                <Container className="my-4">
                  <div style={{ padding: '1rem' }}>
                    <Collapsible
                      key={'moreInfoLink'}
                      headerBackgroundColor={exactWhite}
                      customCollapsibleHeaderStyle={{ zIndex: 1000 }}
                      header={`${
                        i18n.t('moreInfoLink', {
                          ns: 'modals',
                        }) as string
                      }`}
                      customHeaderStyle={{ flexGrow: 1, display: 'block' }}
                      customBodyStyle={{ padding: 0 }}
                    >
                      <div
                        style={{
                          padding: '1rem',
                          margin: '0rem',
                          width: '100%',
                          background: 'var(--exact-white)',
                          gap: '1rem',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <Input
                          id="moreInfoLink"
                          type="text"
                          label={
                            i18n.t('moreInfoLink', {
                              ns: 'modals',
                            }) as string
                          }
                          onChange={this.handleChangemoreInfoLink}
                          placeholder={'https://...'}
                          value={this.state.moreInfoLink}
                        />

                        <Button
                          type="button"
                          color={'black-outline'}
                          onClick={this.handleSaveMoreInfoLink}
                          loading={this.state.savingMoreInfoLink}
                        >
                          {
                            i18n.t('confirm', {
                              ns: 'taskManager',
                            }) as string
                          }
                        </Button>
                      </div>
                    </Collapsible>
                  </div>
                </Container>
              )}
              {openItem.status === 'edit' && showBot && (
                <Container className="my-4">
                  <div style={{ padding: '1rem' }}>
                    <Button onClick={() => this.setState({ isNews: true })}>{`${
                      i18n.t('smartBot', {
                        ns: 'taskManager',
                      }) as string
                    }`}</Button>
                    {isNews && (
                      <APopover
                        show={isNews}
                        curveBorder={true}
                        marginToTarget={8}
                        placement={'bottom'}
                        target={<div></div>}
                        onShowChange={(show) => this.setState({ isNews: show })}
                      >
                        <div
                          className="flex flex-col"
                          style={{
                            padding: '1rem',
                            width: '25rem',
                            background: exactWhite,
                          }}
                        >
                          <label htmlFor="news">{`${
                            i18n.t('smartBot', {
                              ns: 'taskManager',
                            }) as string
                          }`}</label>
                          <Input
                            type="checkbox"
                            id="systemInstruct"
                            label={`${
                              i18n.t('enableSystemInstruction', {
                                ns: 'taskManager',
                              }) as string
                            }`}
                            checked={this.state.enableSystemInstruction}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) =>
                              this.setState({
                                enableSystemInstruction: e.target.checked,
                              })
                            }
                          />
                          {this.state.enableSystemInstruction && (
                            <Input
                              type="text"
                              id="systemInstruction"
                              label={`${
                                i18n.t('systemInstruction', {
                                  ns: 'taskManager',
                                }) as string
                              }`}
                              value={this.state.systemInstruction}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) =>
                                this.setState({
                                  systemInstruction: e.target.value,
                                })
                              }
                            />
                          )}
                          <Input
                            id="enableSearch"
                            label={`${
                              i18n.t('enableSearch', {
                                ns: 'taskManager',
                              }) as string
                            }`}
                            type="checkbox"
                            checked={this.state.enableSearch}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) =>
                              this.setState({ enableSearch: e.target.checked })
                            }
                          />
                          <Select
                            options={this.chatBotOptions}
                            values={
                              this.state.selectedChatOption && [
                                this.state.selectedChatOption,
                              ]
                            }
                            onChangeValues={(values: IOption[]) => {
                              this.setState({ selectedChatOption: values[0] });
                            }}
                            allowRemove={false}
                            multiChoice={false}
                          />
                          <h4
                            className="w-full"
                            style={{ whiteSpace: 'pre-wrap' }}
                          >
                            {this.state.selectedChatOption &&
                            this.state.selectedChatOption
                              ? this.state.selectedChatOption.description
                              : (i18n.t('askingNews', {
                                  ns: 'taskManager',
                                }) as string)}
                          </h4>
                          <Input
                            type="text"
                            id="askingNews"
                            value={this.state.askedNewsContent}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) =>
                              this.setState({
                                askedNewsContent: e.target.value,
                              })
                            }
                          />
                          <Button
                            type="button"
                            color={'black-outline'}
                            onClick={this.handleAskedQuestionToChatBot}
                            loading={this.state.searchingNews}
                          >
                            {
                              i18n.t('confirm', {
                                ns: 'taskManager',
                              }) as string
                            }
                          </Button>
                        </div>
                      </APopover>
                    )}
                  </div>
                </Container>
              )}
            </div>
          </div>
        </QuillContainer>
      </>
    ) as any;
  }
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = () => ({
  save: (content: string, item: IProviderItemViewWithData) =>
    appDispatch(update_ck({ content, item, progressCallBack: null })),
});

export default connect(null, mapDispatchToProps)(QuillManagerModal as any);
